import {
  locale,
  Dialog,
  Pagination,
  Table,
  TableColumn,
  Card,
  Popover,
  Tag,
  Tree,
  ColorPicker,
  Button,
  DatePicker,
  TimePicker,
  Tooltip,
  Collapse,
  CollapseItem,
  Badge,
  Loading,
  MessageBox,
  Notification,
  Message,
} from "element-ui";
import "./lib/theme-standard/index.scss"; // themeはローカルの物を参照.

/**
 * 基本的にはnode_modules/element-ui/src/index.jsのinstallを移植している
 */
export function load(Vue, opts = {}) {
  locale.use(opts.locale);
  locale.i18n(opts.i18n);

  Vue.component(Dialog.name, Dialog);
  Vue.component(Pagination.name, Pagination);
  Vue.component(Table.name, Table);
  Vue.component(TableColumn.name, TableColumn);
  Vue.component(Card.name, Card);
  Vue.component(Popover.name, Popover);
  Vue.component(Tag.name, Tag);
  Vue.component(Tree.name, Tree);
  Vue.component(ColorPicker.name, ColorPicker);
  Vue.component(Button.name, Button);
  Vue.component(DatePicker.name, DatePicker);
  Vue.component(TimePicker.name, TimePicker);
  Vue.component(Tooltip.name, Tooltip);
  Vue.component(Collapse.name, Collapse);
  Vue.component(CollapseItem.name, CollapseItem);
  Vue.component(Badge.name, Badge);

  Vue.use(Loading.directive);

  Vue.prototype.$ELEMENT = {
    size: opts.size || '',
    zIndex: opts.zIndex || 2000
  };

  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$notify = Notification;
  Vue.prototype.$message = Message;
}
